
  export default {
    meta: {
      breadcrumbs: [['i18n/home', '/'], ['i18n/about', '/about/', 'mobile'], 'i18n/team']
    },
    middleware: ['breadcrumbs', 'jumbotron', 'meta-tags'],
    data () {
      return {
        team: {
          dave: {
            email: 'david.kerr@bonkers.ie',
            linkedIn: 'darkdiver',
            name: 'David Kerr, CDir',
            phone: '012560500',
            title: 'Founder & Group CEO'
          },
          enda: {
            email: 'enda.brazel@bonkers.ie',
            linkedIn: 'enda-brazel-1374174a',
            name: 'Enda Brazel',
            phone: '012560500',
            title: 'Managing Director - Bonkers Financial Services'
          }
        }
      };
    }
  };
